export default __webpack_public_path__ + "static/media/5.19.69976e49.mp3";